import React, { Component } from 'react'

import { Icon, Tooltip } from 'antd'

class DashboardSingleBox extends Component {
  render () {
    const { title, number, info } = this.props

    return (
      <div style={{ padding: '10px 15px', border: '1px solid #e8e8e8' }}>

        <div
          style={{
            fontWeight: 'bold',
            height: 20,
            position: 'relative',
            top: -20,
            marginBottom: -20,
            padding: '0 5px',
            background: '#fff'
          }}
        >
          {title}
        </div>

        <div style={{ fontSize: 30, textAlign: 'center' }}>{number}</div>

        <Tooltip title={info}>
          <Icon style={{ position: 'absolute', bottom: 10, right: 10 }} type='info-circle' />
        </Tooltip>

      </div>
    )
  }
}

export default DashboardSingleBox



// WEBPACK FOOTER //
// ./src/components/Dashboard/DashboardSingleBox.js